<p><b>Text editor</b></p>
<div class="box">
  <form [formGroup]="form">
    <pa-editor
      formControlName="text"
      label="Описание"
      tooltip="Поддерживает базовое форматирование"
      placeholder="Введите текст"
      hint="Хинт для описания поля"
      [editorStyle]="{'height': '320px'}"
    ></pa-editor>
  </form>
</div>
